// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { GetCustomerListData, GetCustomerListResponses, GetCustomerListErrors, GetEnergyLabelListData, GetEnergyLabelListResponses, GetEnergyLabelListErrors, GetEnergyPerformanceFeeCategoryListData, GetEnergyPerformanceFeeCategoryListResponses, GetEnergyPerformanceFeeCategoryListErrors, GetResidenceTypeListData, GetResidenceTypeListResponses, GetResidenceTypeListErrors, GetResidenceTypeData, GetResidenceTypeResponses, GetResidenceTypeErrors, GetResidenceTypeImageData, GetResidenceTypeImageResponses, GetResidenceTypeImageErrors, GetResidenceTypeFiltersData, GetResidenceTypeFiltersResponses, GetScenarioListData, GetScenarioListResponses, GetScenarioListErrors, GetScenarioData, GetScenarioResponses, GetScenarioErrors, GetSituationListData, GetSituationListResponses, GetSituationListErrors, GetSituationData, GetSituationResponses, GetSituationErrors } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get customers
 * Gets a list of customers.
 */
export const getCustomerList = <ThrowOnError extends boolean = false>(options: Options<GetCustomerListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCustomerListResponses, GetCustomerListErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers',
        ...options
    });
};

/**
 * Get energy labels
 * Gets a list of energy labels.
 */
export const getEnergyLabelList = <ThrowOnError extends boolean = false>(options: Options<GetEnergyLabelListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEnergyLabelListResponses, GetEnergyLabelListErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/energy-labels',
        ...options
    });
};

/**
 * Get energy performance fee categories
 * Gets a list of energy performance fee categories.
 */
export const getEnergyPerformanceFeeCategoryList = <ThrowOnError extends boolean = false>(options: Options<GetEnergyPerformanceFeeCategoryListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEnergyPerformanceFeeCategoryListResponses, GetEnergyPerformanceFeeCategoryListErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/energy-performance-fee-categories',
        ...options
    });
};

/**
 * Get residence types
 * Gets a list of residence types.
 */
export const getResidenceTypeList = <ThrowOnError extends boolean = false>(options: Options<GetResidenceTypeListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetResidenceTypeListResponses, GetResidenceTypeListErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types',
        ...options
    });
};

/**
 * Get residence type
 * Gets a single residence type.
 */
export const getResidenceType = <ThrowOnError extends boolean = false>(options: Options<GetResidenceTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetResidenceTypeResponses, GetResidenceTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{id}',
        ...options
    });
};

/**
 * Get image for residence type
 * Gets the image for a specific residence type.
 */
export const getResidenceTypeImage = <ThrowOnError extends boolean = false>(options: Options<GetResidenceTypeImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetResidenceTypeImageResponses, GetResidenceTypeImageErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{residenceTypeId}/image',
        ...options
    });
};

/**
 * Get residence type filters
 * Gets a set of filters that can be used to filter a list of residence types.
 */
export const getResidenceTypeFilters = <ThrowOnError extends boolean = false>(options: Options<GetResidenceTypeFiltersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetResidenceTypeFiltersResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/filters',
        ...options
    });
};

/**
 * Get scenarios
 * Gets a list of scenarios.
 */
export const getScenarioList = <ThrowOnError extends boolean = false>(options: Options<GetScenarioListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetScenarioListResponses, GetScenarioListErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{residenceTypeId}/situations/{situationId}/scenarios',
        ...options
    });
};

/**
 * Get scenario
 * Gets a specific scenario.
 */
export const getScenario = <ThrowOnError extends boolean = false>(options: Options<GetScenarioData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetScenarioResponses, GetScenarioErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{residenceTypeId}/situations/{situationId}/scenarios/{id}',
        ...options
    });
};

/**
 * Get situations
 * Gets a list of situations.
 */
export const getSituationList = <ThrowOnError extends boolean = false>(options: Options<GetSituationListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSituationListResponses, GetSituationListErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{residenceTypeId}/situations',
        ...options
    });
};

/**
 * Get situation
 * Gets a single situation
 */
export const getSituation = <ThrowOnError extends boolean = false>(options: Options<GetSituationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSituationResponses, GetSituationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{residenceTypeId}/situations/{id}',
        ...options
    });
};